import React from 'react';

const TONE_CLASSES = {
  emerald: 'bg-emerald-50 text-emerald-600',
  amber: 'bg-amber-50 text-amber-600',
  red: 'bg-red-50 text-red-600',
  blue: 'bg-blue-50 text-blue-600',
  gray: 'bg-gray-100 text-gray-600',
};

/**
 * A small colored status pill, shared across the admin console. Color is
 * informational, not decorative: emerald = healthy/on, amber = idle/
 * expected-off (the common case, not an alarm), red = unreachable/failed,
 * blue = something running right now (pass `pulse` too — motion is reserved
 * exclusively for that state), gray = a neutral count/info chip.
 */
const StatusChip = ({ tone = 'gray', icon: Icon, pulse = false, children }) => (
  <span
    className={`inline-flex items-center gap-1 text-xs px-1.5 py-0.5 rounded ${TONE_CLASSES[tone] || TONE_CLASSES.gray}`}
  >
    {Icon && <Icon className={`w-3 h-3 ${pulse ? 'animate-pulse' : ''}`} />}
    {children}
  </span>
);

export default StatusChip;
